import React, { useState, useEffect } from 'react'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import Home from './home/home'
import Login from './login/login'
import Employee from './employee/page'
import Navbar from './components/App/Navbar'
import Sidebar from './components/App/SiderBar'
import Attendance from './attendance/page'
import EmployeeDetails from './employee/employeeDetails'
import SalaryDetails from './salary/salaryDetails.jsx'
import Holidays from './holiydays/page'
import Salary from './salary/page.jsx'
import LeavePolicy from './LeavePolicy/page.jsx'
import { getCookie } from './utils/api/cookies'
import * as api from './utils/api/apiClient'
import ToastContainer from '../src/components/ToastContainer'

const AuthenticatedLayout = ({ children }) => (
  <div className='flex min-h-screen bg-gray-100'>
    <Sidebar />
    <main className='flex-1 md:ml-64 '>
      <Navbar />
      <div className='p-2  md:p-4'>{children}</div>
    </main>
  </div>
)

// Protected Route Component
const ProtectedRoute = ({ isLogin, children }) => {
  return isLogin ? children : <Navigate to='/login' />
}

function AppRoutes({ isLogin, setIsLogin }) {
  const checkLogin = () => {
    const token = getCookie('token')
    if (!token) {
      setIsLogin(false)
    } else {
      api.setAuthHeader('token')
    }
  }

  useEffect(() => {
    const loginInterval = setInterval(checkLogin, 1000)
    return () => clearInterval(loginInterval)
  }, [isLogin])

  return (
    <Routes>
      {/* Login Route */}
      <Route path='/login' element={<Login />} />

      {/* Protected Routes */}
      <Route
        path='/'
        element={
          <ProtectedRoute isLogin={isLogin}>
            <AuthenticatedLayout>
              <Home />
            </AuthenticatedLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/employee'
        element={
          <ProtectedRoute isLogin={isLogin}>
            <AuthenticatedLayout>
              <Employee />
            </AuthenticatedLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/employee/:id'
        element={
          <ProtectedRoute isLogin={isLogin}>
            <AuthenticatedLayout>
              <EmployeeDetails />
            </AuthenticatedLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/attendance'
        element={
          <ProtectedRoute isLogin={isLogin}>
            <AuthenticatedLayout>
              <Attendance />
            </AuthenticatedLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/leavePolicy'
        element={
          <ProtectedRoute isLogin={isLogin}>
            <AuthenticatedLayout>
              <LeavePolicy />
            </AuthenticatedLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/salary'
        element={
          <ProtectedRoute isLogin={isLogin}>
            <AuthenticatedLayout>
              <Salary />
            </AuthenticatedLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path='/salary/:id'
        element={
          <ProtectedRoute isLogin={isLogin}>
            <AuthenticatedLayout>
              <SalaryDetails />
            </AuthenticatedLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path='/holidays'
        element={
          <ProtectedRoute isLogin={isLogin}>
            <AuthenticatedLayout>
              <Holidays />
            </AuthenticatedLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}

export default function App() {
  const [isLogin, setIsLogin] = useState(() => {
    const token = getCookie('token')
    if (token) {
      api.setAuthHeader('token')
      return true
    }
    return false
  })

  return (
    <BrowserRouter>
      <AuthProvider value={{ isLogin, setIsLogin }}>
        {/* <Navbar /> */}
        <AppRoutes isLogin={isLogin} setIsLogin={setIsLogin} />
      </AuthProvider>
      <ToastContainer />
    </BrowserRouter>
  )
}
